import React from 'react';
import { Box, VStack, Text, Heading } from '@chakra-ui/react';
import Icon from './Icon';

const EmptyState = ({
  icon,
  title,
  subtitle,
  action,
  ...props
}) => {
  return (
    <Box
      py={12}
      px={6}
      textAlign="center"
      {...props}
    >
      <VStack spacing={4}>
        {icon && (
          <Box
            fontSize="4xl"
            color="gray.400"
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            {typeof icon === 'string' ? (
              <Icon name={icon} style={{ fontSize: '48px' }} />
            ) : (
              icon
            )}
          </Box>
        )}
        {title && (
          <Heading size="md" color="gray.700">
            {title}
          </Heading>
        )}
        {subtitle && (
          <Text color="gray.600" maxW="md">
            {subtitle}
          </Text>
        )}
        {action && <Box mt={4}>{action}</Box>}
      </VStack>
    </Box>
  );
};

export default EmptyState;










